import { useEffect, useState } from 'react';
import nProgress from 'nprogress';
import { showLog } from 'src/utils/debug-log';

export function useNprogress() {
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    nProgress.configure({ showSpinner: true });

    const startLoading = () => {
      showLog('startLoading');
      setLoading(true);
      nProgress.start();
    };

    const stopLoading = () => {
      showLog('stopLoading');
      setLoading(false);
      nProgress.done();
    };

    document.addEventListener('loadingStart', startLoading);
    document.addEventListener('loadingStop', stopLoading);

    return () => {
      document.removeEventListener('loadingStart', startLoading);
      document.removeEventListener('loadingStop', stopLoading);
    };
  }, []);

  return isLoading;
}
